import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function PageTitle() {
  const location = useLocation();

  useEffect(() => {
    const titles = {
        '/': 'Dr. Surbhi Rustagi | Gynaecologist in Delhi',
        '/home': 'Dr. Surbhi Rustagi | Gynaecologist in Delhi',
        '/about': 'About Dr. Surbhi Rustagi | Gynaecologist in Delhi',
        '/services': 'Gynaecology & Obstetrics Services | Dr. Surbhi Rustagi',
        '/stories': 'Patient Stories & Reviews | Dr. Surbhi Rustagi',
        '/contact': 'Contact Dr. Surbhi Rustagi | Gynaecologist in Delhi',
        '/appointment': 'Book an Appointment | Dr. Surbhi Rustagi',
    };

    document.title = titles[location.pathname] || 'Dr. Surbhi Rustagi | Gynaecologist';
  }, [location.pathname]);

  return null;
}

export default PageTitle;